import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';

export const routes = {
  inventoryUnitsForOrderPath: orderId => `api/CMSv2/inventoryUnit/order/${orderId}`,
  inventoryUnitsForOrderMultiplePath: orderIdsQuery => `api/CMSv2/inventoryUnit/order/multiple?${orderIdsQuery}`,
  bulkUpdateInventoryUnits: () => 'api/CMSv2/inventoryUnit/bulkUpdate',
  bulkUpdateInventoryDetails: () => 'api/CMSv2/inventoryUnit/details/bulkUpdate',
  inventoryUnitsForOrderAndProduct: (orderId, productId) => `api/CMSv2/inventoryUnit/order/${orderId}/${productId}`,
  holdInventoryUnits: () => 'api/CMSv2/inventoryUnit/hold',
  searchLineItemsPath: () => `/api/CMSv2/inventoryUnit/SearchLineItems`,
  addToBLPath: () => `/api/CMSv2/inventoryUnit/AddToBL`,
  updateInventoryUnitsByOrdersPath: () => 'api/CMSv2/inventoryUnit/updateByOrderIds'
};

export const getInventoryUnitsForMultipleOrders = async orderIdsQuery =>{
    return await authFetch.get(routes.inventoryUnitsForOrderMultiplePath(orderIdsQuery))
}

export const getInventoryUnitsForOrder = async orderId =>
  await authFetch
    .get(routes.inventoryUnitsForOrderPath(orderId))
    .then(({ data }) => {

      data.forEach(item => {

        item = {
          ...item,
          arriveDate: item.arriveDate ? new Date(item.arriveDate) : null,
          shipDate: item.shipDate ? new Date(item.shipDate) : null,
          storageLastFreeDay: item.storageLastFreeDay ? new Date(item.storageLastFreeDay) : null,
          hold: {
            ...item.hold,
            date: new Date(item.hold?.date),
            releaseDate: item.hold?.releaseDate ? new Date(item.hold?.releaseDate) : null
          }
        };
      });

      return data;
    })
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const bulkUpdateInventoryUnits = changes =>
  authFetch
    .put(routes.bulkUpdateInventoryUnits(), changes)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const bulkUpdateInventoryDetails = changes =>
  authFetch
    .put(routes.bulkUpdateInventoryDetails(), changes)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const inventoryUnitsForOrderAndProduct = (orderId, productId) =>
  makeRequest(authFetch.get(routes.inventoryUnitsForOrderAndProduct(orderId, productId)));

export const updateInventoryUnitsByOrders = changes =>
  makeRequest(authFetch.put(routes.updateInventoryUnitsByOrdersPath(), changes));

export const holdInventoryUnits = holds =>
  authFetch
    .put(routes.holdInventoryUnits(), holds)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const searchLineItems = (query) => makeRequest(authFetch.get(`${routes.searchLineItemsPath()}${getQueryParams(query)}`));
export const addToBL = (data) => makeRequest(authFetch.put(routes.addToBLPath(), data));